module.exports = __webpack_public_path__ + "static/media/500.4893556f.svg";